import React from 'react'
import { useTranslation } from 'react-i18next'

function Story() {
  const { t } = useTranslation()

  return (
    <section id="story" className="section section-warm story" aria-labelledby="story-heading">
      <div className="container-wide story-grid">
        <div className="story-media">
          <img
            src="/images/pupusa-comal.jpg"
            alt={t('story.pupusaAlt')}
            className="story-image"
            width="800"
            height="800"
            loading="lazy"
          />
          <video
            className="story-video"
            src="/images/promo.mp4"
            autoPlay
            muted
            loop
            playsInline
            aria-label={t('story.videoAlt')}
          />
        </div>
        <div className="story-text">
          <h2 id="story-heading">{t('story.heading')}</h2>
          <p className="story-body">{t('story.body')}</p>
          <p className="story-signature">{t('story.signature')}</p>
        </div>
      </div>
    </section>
  )
}

export default Story
